////
/// ============================================================================
/// COMPONENT / Submenu
/// ============================================================================
///
/// @group components
////

import "../vendors/jquery.accordion";

export default () => {

    window.$ = jQuery;

    var submenu = $('.js-submenu');

    if (!submenu.length) {
        return;
    }

    $('<span class="submenu__accordion">').appendTo(submenu.find('.submenu__dropdown').children('.submenu__link'));

    submenu.find('.submenu__item--parent').addClass('submenu__item--open');

    submenu.accordion({
        panelSelector	: '.submenu__dropdown',
        titleSelector	: '> .submenu__link .submenu__accordion',
        contentSelector	: '.submenu__sub',
        activeClass		: 'submenu__item--open'
    });

};
